import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { CarouselItem } from "@/components/ui/carousel";
import { cn } from "@/utils/utils";
import { DarkCard } from "../dark-card";

export interface CarouselItemType {
  id: number;
  quote: string;
  quoter: {
    image: string;
    fullName: string;
    title: string;
  };
}

export const OnboardingCarouselItem = ({
  item,
  isActive,
}: {
  item: CarouselItemType;
  isActive: boolean;
}) => {
  return (
    <CarouselItem className="my-32 max-w-fit cursor-grab">
      <DarkCard
        className={cn("h-[300px] w-[534px]")}
        borderClassName={cn(
          "transition-all duration-500",
          !isActive && "scale-90 shadow-sm",
        )}
      >
        <div className="flex-1">
          <p className="z-30 text-lg text-white">&ldquo;{item.quote}&rdquo;</p>
        </div>
        <div className="flex items-center gap-4">
          <Avatar className="h-9 w-9">
            <AvatarImage src={item.quoter.image} alt={item.quoter.fullName} />
            <AvatarFallback>
              {item.quoter.fullName
                .split(" ")
                .map((n: string) => n[0])
                .join("")
                .toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col">
            <p className="text-base text-white">{item.quoter.fullName}</p>
            <p className="text-sm text-gray-400">{item.quoter.title}</p>
          </div>
        </div>
      </DarkCard>
    </CarouselItem>
  );
};
